import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M3 5h6', key: '1ltk0q' }],
  ['path', { d: 'M3 12h13', key: 'ppymz1' }],
  ['path', { d: 'M3 19h13', key: 'bpdczq' }],
  ['path', { d: 'm16 8-3-3 3-3', key: '1pjpp6' }],
  ['path', { d: 'M21 19V7a2 2 0 0 0-2-2h-6', key: '4zzq67' }],
];

/**
 * @component @name ListStart
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA1aDYiIC8+CiAgPHBhdGggZD0iTTMgMTJoMTMiIC8+CiAgPHBhdGggZD0iTTMgMTloMTMiIC8+CiAgPHBhdGggZD0ibTE2IDgtMy0zIDMtMyIgLz4KICA8cGF0aCBkPSJNMjEgMTlWN2EyIDIgMCAwIDAtMi0yaC02IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/list-start
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const ListStart = createLucideIcon('list-start', __iconNode);

export default ListStart;
